import React from 'react';
import MermaidDiagram from 'volto-diagram/components/MermaidDiagram';
import 'volto-diagram/components/diagram.css';

// react-markdown `components` override (DR-2026-271): fenced ```mermaid
// code renders as a diagram via the shared volto-diagram component.
// react-markdown emits <pre><code className="language-mermaid">…</code></pre>;
// intercept at <pre> so the diagram is not nested inside a <pre>.
const textOf = (children) =>
  React.Children.toArray(children)
    .map((c) => (typeof c === 'string' ? c : ''))
    .join('');

export const markdownComponents = {
  pre: ({ node, children, ...props }) => {
    const child = React.Children.toArray(children)[0];
    const cls = (child && child.props && child.props.className) || '';
    if (/\blanguage-mermaid\b/.test(cls)) {
      return (
        <div className="diagram-block">
          <MermaidDiagram source={textOf(child.props.children).replace(/\n$/, '')} />
        </div>
      );
    }
    return <pre {...props}>{children}</pre>;
  },
};

export default markdownComponents;
